import React from 'react';
import TextSearch from '../icons/TextSearch';

export default function NoData() {
  return (
    <span
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <span
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          border: '1px solid #e6e6e6',
          borderRadius: 10,
          width: 108,
          padding: 10,
          margin: 16,
        }}
      >
        <TextSearch size={64} color={'#cdcdcd'} />
        <span style={{ color: '#929292' }}>No data</span>
      </span>
    </span>
  );
}
